import React from "react";

/**
 * Message list component that displays chat messages
 * @param {Object} props
 * @param {Array} props.messages - Array of message objects
 * @param {boolean} props.isSending - Whether a message is being sent
 */
const MessageList = ({ messages, isSending }) => {
  return (
    <div className="message-list">
      {messages.map((message) => (
        <div
          key={message.id}
          className={`message ${
            message.isSystem ? "system" : message.isUser ? "user" : "assistant"
          } ${message.isError ? "error" : ""}`}
        >
          <span className="username">{message.username}:</span>
          <span className="text" style={{ whiteSpace: "pre-line" }}>
            {message.text}
          </span>
        </div>
      ))}
      {isSending && (
        <div className="message system">
          <span className="username">System:</span>
          <span className="text">
            <span className="spinner"></span>
            Processing your message... (Building the draft Product Requirements
            Document: ~2min, Building the EWA: ~7min)
          </span>
        </div>
      )}
    </div>
  );
};

export default MessageList;
